import { useState, useEffect, useRef } from "react";
import "./component.css";
import { Link, useNavigate } from "react-router-dom";
import Avtar from "../../../asset/img/avtar.jpg";
import { useAdminAuth } from "../../context/AuthContext";
import { ADMIN_PREFIX } from "../../../lib/lib";

const Component = ({sidebarOpen, toggleSidebar, brandName}) => {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();
  const [notificationDropdownVisible, setNotificationDropdownVisible] = useState(false);
  const [avatarDropdownVisible, setAvatarDropdownVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const notifications = [
    { title: "New user registered", description: "John Doe has signed up." },
    {
      title: "Password changed",
      description: "Admin password updated successfully.",
    },
    {
      title: "System update",
      description: "System update is scheduled for tonight.",
    },
    {
      title: "User banned",
      description: "User Jane Doe has been banned for violating terms.",
    },
  ];

  const suggestions = [
    "User Management",
    "System Logs",
    "Settings",
    "Notifications",
    "Profile",
    "Analytics",
    "Reports",
    "New User",
    "Password Reset",
    "System Update",
  ];

  const notificationRef = useRef(null);
  const avatarRef = useRef(null);

  const handleLogout = async () => {
    try {
      await logout();
      navigate(`${ADMIN_PREFIX}/login`);
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const handleNotificationClick = (e) => {
    e.stopPropagation();
    setNotificationDropdownVisible((prev) => !prev);
    setAvatarDropdownVisible(false);
  };

  const handleAvatarClick = (e) => {
    e.stopPropagation();
    setAvatarDropdownVisible((prev) => !prev);
    setNotificationDropdownVisible(false);
  };

  const handleClickOutside = (e) => {
    if (
      notificationRef.current &&
      !notificationRef.current.contains(e.target) &&
      avatarRef.current &&
      !avatarRef.current.contains(e.target)
    ) {
      setNotificationDropdownVisible(false);
      setAvatarDropdownVisible(false);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (value.trim() === "") {
      setFilteredSuggestions([]);
    } else {
      const filtered = suggestions.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(filtered);
    }
  };

  const handleSuggestionClick = (value) => {
    setSearchQuery(value);
    setFilteredSuggestions([]);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="navbar-container">
      
      <div className="left-section">
        { !sidebarOpen && (<div className="logo-flx1"><h2 style={{ color: '#0052CC' }}>{brandName}</h2></div>)}
      </div>

      <div className="right-section">
        
        {/* Search with Suggestions */}
        <div className="search-container">
          <input
            type="text"
            className="search-input"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
          <i className="ri-search-line search-icon"></i>

          {filteredSuggestions.length > 0 && (
            <ul className="suggestions-dropdown">
              {filteredSuggestions.map((item, index) => (
                <li key={index} onClick={() => handleSuggestionClick(item)}>
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Notification Dropdown */}
        <div
          className="notification-container position-relative"
          onClick={handleNotificationClick}
          ref={notificationRef}
        >
          <i className="ri-notification-line not_icon"></i>
          {notifications.length > 0 && (
            <span className="notification-count">{notifications.length}</span>
          )}
          {notificationDropdownVisible && (
            <div className="notification-dropdown">
              {notifications.map((notification, index) => (
                <Link to={`/admin/notification-details/${index}`} key={index}>
                  <div className="notification-item">
                    <strong>{notification.title}</strong>
                    <p>{notification.description}</p>
                  </div>
                </Link>
              ))}
              <div className="show-all">
                <Link to="/admin/notifications">Show All</Link>
              </div>
            </div>
          )}
        </div>

        {/* Avatar Dropdown */}
        <div
          className="avatar-container position-relative"
          onClick={handleAvatarClick}
          ref={avatarRef}
        >
          <img src={Avtar} alt="Avatar" className="avatar-image" />
          {avatarDropdownVisible && (
            <div className="avatar-dropdown">
              <Link to="/admin/account">
                <div className="dropdown-item">Account</div>
              </Link>
              <div className="dropdown-item" onClick={handleLogout}>
                Logout
              </div>
            </div>
          )}
        </div>

        {/* Hamburger Menu */}
        <div id="hamburger" className="logoFlx2">
            <span className="hamburger" style={{ fontSize: "30px", cursor: "pointer" }} onClick={toggleSidebar} ><i className="ri-menu-3-line"></i></span>
            {/* {!sidebarOpen && ( <span className="hamburger" style={{ fontSize: "30px", cursor: "pointer" }} onClick={toggleSidebar} ><i className="ri-menu-3-line"></i></span>)} */}
        </div>

      </div>
    </div>
  );
};

export default Component;
